import events from 'events-bus';
import { useState, useEffect } from 'react';

const useToken = () => {
    const [token, setToken] = useState({ token: null, payload: null });
    useEffect(() => {
        function tokenListener(eventName, data) {
            setToken(data);
        }
        events.on('AUTH-SUCCESS-EVENT-v1', tokenListener);
        return () => {
            events.off(tokenListener);
        };
    }, []);
    return token;
};

export { useToken };
//# sourceMappingURL=useToken.js.map
